// Request IDs and location samples are ephemeral. Never persist them or include them in URLs/logs.
export const ARRIVAL_ACCURACY_LIMIT_M = 100;
export const newArrivalRequestId = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  if (!globalThis.crypto?.getRandomValues) throw new Error("Secure request identifiers unavailable");
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
export const evidenceRecords = (data) => Array.isArray(data) ? data : Array.isArray(data?.records) ? data.records : [];
export const confirmedEvidence = (record) => typeof record?.id === "string" && !!record.id && typeof record.server_received_at === "string" && Number.isFinite(Date.parse(record.server_received_at));
